import { useState, useRef, useEffect } from "react";
import { Globe, Check } from "lucide-react";
import { useI18n, LANGUAGES } from "../i18n";

export const LanguageSwitcher = ({ dark = false, testId = "language-switcher" }) => {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid={testId}
        onClick={() => setOpen((v) => !v)}
        className={`flex items-center gap-1.5 rounded-full px-3 py-2 text-sm font-medium transition-colors ${
          dark ? "text-white/80 hover:text-white hover:bg-white/10" : "text-slate-600 hover:text-[#001489] hover:bg-slate-100"
        }`}
      >
        <Globe size={16} />
        <span className="font-mono-accent text-xs uppercase">{current.code}</span>
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-44 max-h-80 overflow-auto rounded-xl bg-white border border-slate-200 shadow-xl py-2 z-50">
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className="w-full flex items-center justify-between gap-3 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"
            >
              <span className="flex items-center gap-2"><span>{l.flag}</span>{l.label}</span>
              {l.code === lang && <Check size={15} className="text-[#001489]" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
